import core from '~/core/scripts';
import '../styles/index.styl';
import $ from 'jquery';
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import * as d3Dsv from 'd3-dsv';
import {MapList} from '../components/MapList';
import {Button} from '../components/Button';
import {CurrentWinter} from '../components/CurrentWinter';
import {orderBy} from 'lodash';


const { dsvFormat } = d3Dsv;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.csv = dsvFormat(';');
    this.state = {
      mapdata: null,
      apidata: null,
      showAll: false
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    $.get('data/daten.csv').done(res => {
      const data = this.csv.parse(res);
      this.setState({
        mapdata: orderBy(data, function(o) {return o.winter_id.split("_")[0]}, 'desc')
      });
    });
  }
  handleClick() {
    this.setState(prevState => ({
      showAll: !prevState.showAll
    }));
  }
  render() {
    //console.log(this.state.apidata);
    return (
      <Fragment>
        <h2 className="text-headline">Alle Winter seit 1960</h2>
        <MapList mapdata={this.state.mapdata} showAll={this.state.showAll}/>
        <Button onClick={this.handleClick} showAll={this.state.showAll}/>
      </Fragment>
    );
  }
}

const appContainer = document.getElementById('all-winter');
if (appContainer) {
  ReactDOM.render((
    <App/>
  ), appContainer);
}
const bigMapContainer = document.getElementById('current-winter');
if (appContainer) {
  ReactDOM.render((
    <CurrentWinter/>
  ), bigMapContainer);
}

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`../layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}
